<template>
    <form novalidate class="md-login-screen-bg md-flex-center-center" @submit.prevent="onSubmit">
        <md-card class="md-form-card md-layout-item md-form-input md-medium-size-90 cardBoxForgot" v-if="!success">
            <md-card-header>
                <div class="md-login-img">
                    <img class="logo" src="../assets/polsat2.png" alt="logo">
                </div>
                <h1 class="md-login-title">
                    {{ $t('views.forgottenPassword.title') }}
                </h1>
            </md-card-header>
            <md-card-content>
                <SnackBar />
                <div class="md-layout md-gutter">
                    <div class="md-layout-item md-small-size-100">
                        <md-field :class="getValidationClass('emailOrUserName')">
                            <label for="emailOrUserName">{{ $t('views.forgottenPassword.form.emailOrUserName') }}</label>
                            <md-input name="emailOrUserName" id="emailOrUserName" autocomplete="emailOrUserName" v-model="form.emailOrUserName"
                                      :disabled="sending" required />
                            <span class="md-error" v-if="!$v.form.emailOrUserName.required">{{ $t('validation.required') }}</span>
                            <server-error v-else :server-errors="serverErrors" field-name="emailOrUserName" />
                        </md-field>
                    </div>
                </div>
            </md-card-content>

            <md-progress-bar md-mode="indeterminate" v-if="sending" />

            <md-card-actions md-alignment="space-between">
                <md-button class="md-form-btn-cancel forgot-button" to="/login">
                    {{ $t('views.forgottenPassword.back') }}
                </md-button>
                <md-button type="submit" class=" md-header-btn" :disabled="sending">
                    {{ $t('views.forgottenPassword.form.submit') }}
                </md-button>
            </md-card-actions>
        </md-card>
        <md-card v-if="success && !sending" class="card md-layout-item md-size-30 md-small-size-90">
            <md-card-content class="md-layout md-alignment-center-center">
                <span class="md-subheading">
                    {{ $t('views.forgottenPassword.success') }}
                </span>
                <md-button type="submit" class="md-primary md-raised" :disabled="sending" v-if="success && !sending"
                           to="/login">
                    {{ $t('views.forgottenPassword.button.success') }}
                </md-button>
            </md-card-content>
        </md-card>
    </form>
</template>

<script>
    import serverSideValidationErrors from '@/mixins/serverSideValidationErrors';
    import {required} from 'vuelidate/lib/validators';
    import ServerError from '@/components/ServerError';
    import {usersEndpoint} from '@/services/adsign-backend/endpoints';
    import SnackBar from '@/components/SnackBar'
    import store from '../store'

    export default {
        name: 'ForgottenPassword',
        components: {ServerError, SnackBar},
        mixins: [serverSideValidationErrors],
        data: () => ({
            form: {
                emailOrUserName: null
            },
            sending: false,
            success: false
        }),
        validations: {
            form: {
                emailOrUserName: {
                    required
                }
            }
        },
        methods: {
            onSubmit() {
                this.$v.$touch();

                if (!this.$v.$invalid) {
                    this.serverErrors = {};

                    const formData = {
                        emailOrUserName: this.form.emailOrUserName
                    }

                    this.sending = true;
                    usersEndpoint.resetPassword(formData)
                        .then(() => {
                            this.success = true;
                        })
                        .catch(this.handleServerValidationError)
                        .catch(error => {
                            const errorMessageCode = _.get(error, 'response.data.data.errorMessageCode');
                            let messageKey = '';
                            switch (errorMessageCode) {
                              case 'KEYCLOAK_USER_NOT_FOUND':
                              case 'DB_USER_NOT_FOUND':
                                messageKey = 'views.forgottenPassword.validation.KEYCLOAK_USER_NOT_FOUND';
                                break
                              case 'UNCHANGEABLE_USER_PASSWORD':
                                messageKey = 'views.forgottenPassword.validation.UNCHANGEABLE_USER_PASSWORD'
                                break
                              default:
                                messageKey = 'views.forgottenPassword.validation.DEFAULT'
                            }

                            this.serverErrors = {
                              emailOrUserName: this.$t(messageKey)
                            }
                            store.commit('snackbar/SNACKBAR_TITLE', this.$t(`${messageKey}`))
                            store.commit('snackbar/SNACKBAR_SHOW', true)
                        })
                        .finally(() => {
                            this.sending = false;
                        });
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .cardBoxForgot {
        max-width: 500px;
    }
    .forgot-button{
        background: none;
        box-shadow: none;
    }
    .logo{
        width: 165px;
        display: block;
        margin-left: auto;
        margin-right: auto;
    }
</style>
